/* eslint-disable @typescript-eslint/naming-convention */
import { createTheme, responsiveFontSizes } from '@mui/material/styles';
import { IButtonColorPalette } from '../types';
import palette from './palette';
import breakpoints from './breakpoints';
import typography from './typography';
import overrides from './overrides';
import './global-styles.scss';

export * from './variables';

declare module '@mui/material/styles' {
  interface Palette {
    brand: {
      accent: string;
      secondary: string;
    };
    button: {
      primary: IButtonColorPalette;
      secondary: IButtonColorPalette;
      white: IButtonColorPalette;
    };
    highlight: {
      accent: string;
      actionable: string;
      actionableHover: string;
      neutral: string;
      hover: string;
      white: string;
      error: string;
      textAccentShadow: string;
      boxShadowAccent: string;
      fileSelection: string;
      fileSelectionHover: string;
      progress: string;
    };
  }
  interface PaletteOptions {
    brand: {
      accent: string;
    };
    button: {
      primary: IButtonColorPalette;
      secondary: IButtonColorPalette;
    };
    highlight: {
      accent: string;
      actionable: string;
      actionableHover: string;
      neutral: string;
      hover: string;
      white: string;
      error: string;
      textAccentShadow: string;
      boxShadowAccent: string;
      fileSelection: string;
      fileSelectionHover: string;
      progress: string;
    };
  }
  interface TypeBackground {
    brandAccent: string;
    brandSecondary: string;
    brandTertiary: string;
    brandTransparent: string;
    brandLinearGradient: string;
    brandRadialGradient: string;
    buttonHover: string;
    iconButtonHover: string;
    buttonHoverWhite: string;
    inputDisabled: string;
    positionLink: string;
    socialLink: string;
    stepsCircle: string;
    backgroundPrimary: string;
    whiteLinearGradient: string;
    overlay: string;
    overlayPanel: string;
    popoverBlue: string;
    success: string;
  }
  interface TypeText {
    invertedPrimary: string;
    invertedSecondary: string;
    purple: string;
    brand: string;
    lightGrey: string;
  }
  interface BreakpointOverrides {
    xxl: true;
  }
}

const theme = createTheme({
  palette,
  breakpoints,
  typography,
  shape: { borderRadius: 4 },
  spacing: (factor: number) => factor * 8,
  components: overrides,
});

export const muiTheme = responsiveFontSizes(theme);
